import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { HttpClient } from '@angular/common/http';

/*
  Generated class for the ConfigProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
export interface Config {
  baseUrl: string;
  loginUrl: string;
  route: string;
  training: string;
  ba2: string;
  event: string;
  admin: string;
  origin: string;
}

@Injectable()
export class ConfigProvider {
  testServer: boolean = false;

  testUrl = [
    "https://spooorts.de/"
  ];

  config: Promise<any>;
  active: string;
  constructor(private http: HttpClient, private storage: Storage) {
    this.config = new Promise((resolve, reject) => {
      this.getConfigFile().then(cfg => {
        resolve(cfg);
      });
    });
  }

  getConfigFile(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .get('assets/data/config.json')
        .toPromise()
        .then((values: any) => {
          resolve(values);
        })
        .catch(error => {
          throw 'cannot get coutry.json';
        });
    });
  }

  public async urlConfig(): Promise<Config> {
    return {
      baseUrl: (await this.getUrl()) + (await this.config).url.apiEnd,
      loginUrl: (await this.getUrl()) + (await this.config).url.loginEnd,
      training: (await this.getUrl()) + (await this.config).url.training,
      route: (await this.getUrl()) + (await this.config).url.route,
      admin: (await this.getUrl()) + (await this.config).url.admin,
      ba2: (await this.getUrl()) + (await this.config).url.ba2,
      event: (await this.getUrl()) + (await this.config).url.event,
      origin: await this.getUrl()
    };
  }

  public defaultLanguage = 'de';
  public appId = 'com.spooorts.event';

  urlIndex = 0;
  private async getUrl() {
    let urls: string[] = (await this.config).url.domains;
    // let urls = this.testUrl;

    // let urls = this.testUrl;

    // if (!urls || urls.length === 0) {
    //   urls
    //   this.storage.set('urls', urls);

    // https://uknsowl.com/
    // }

    if (!urls) urls[0] = (this.testServer) ? "http://78.94.23.124/" : "https://spooorts.de/";

    urls[0] = (this.testServer)
      ? urls[0].replace("spooorts.ingenia-it.de", "78.94.23.124").replace("https", "http").replace("spooorts.de", "78.94.23.124").replace("spooorts.de", "78.94.23.124")
      : urls[0].replace("spooorts.ingenia-it.de", "spooorts.de").replace("http:", "https:");

    return urls[this.urlIndex % urls.length];
  }

  lastChange = 0;

  public changeUrl() {
    if (new Date().getTime() - this.lastChange > 1500) {
      this.urlIndex++;
    }
  }

  public switchToInitialUrl() {
    this.urlIndex = 0;
  }

  public testFailover() {

  }
}



// WEBPACK FOOTER //
// /src/providers/config/config.ts